import React, { memo } from 'react';

const ArticleIndexPageResultLoadingCard: React.FC = () => {
  return (
    <div className="space-y-8">
      {/*-- loading image --*/}
      <div className="w-full aspect-[3/2] bg-[#ededed]" />
      {/*-- loading content --*/}
      <div className="space-y-4">
        <div className="space-y-2">
          {/*-- loading heading --*/}
          <div className="w-[92%] h-7 bg-[#ededed]" />
          {/*-- loading date and read time --*/}
          <div className="w-[220px] h-3 bg-[#ededed]" />
        </div>
        {/*-- loading paragraph --*/}
        <div className="space-y-2">
          <div className="w-[88%] h-4 bg-[#ededed]" />
          <div className="w-[96%] h-4 bg-[#ededed]" />
          <div className="w-[92%] h-4 bg-[#ededed]" />
        </div>
      </div>
    </div>
  );
};

export default memo(ArticleIndexPageResultLoadingCard);
